"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AbstractButton = _interopRequireDefault(require("./AbstractButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Spinner = require("./spinner").default;

// maybe use https://github.com/KyleAMathews/react-spinkit ?
var _ref = /*#__PURE__*/_react.default.createElement(Spinner, null);
var _default = exports.default = (0, _AbstractButton.default)('Submit', (classes, props) => {
  const parentStyle = props.block ? {
    position: 'relative'
  } : {
    position: 'relative',
    display: 'inline-block'
  };
  const style = {
    paddingRight: props.loading ? 32 : undefined,
    transition: 'padding 0.2s'
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: parentStyle
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-test-id": props['data-test-id'],
    type: 'submit',
    style: props.style ? Object.assign(style, props.style) : style,
    className: classes.join(' '),
    disabled: props.disabled || props.loading,
    onClick: props.onClick
  }, props.children, !props.loading ? '' : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      right: 0,
      top: '50%'
    }
  }, _ref)));
}, {
  type: 'primary'
});